// extracted by mini-css-extract-plugin
module.exports = {"tabClickable":"styles_tabClickable__21BWI","mobileSelect":"styles_mobileSelect__1grwL","tabs":"styles_tabs__3jmDS","ListStaffHeader":"styles_ListStaffHeader__c8nE7"};